<template>
  <v-app>
    <v-container fluid class="promo-bg">

      <!-- HEADER -->
      <header class="header-box">
        <p class="sub-title">
          Aprovecha las promociones especiales y agrega regalos a tu carrito.
        </p>
      </header>

      <!-- GRID DE TARJETAS -->
      <section class="cards-grid">

        <v-card v-for="item in promoGifts" :key="item.id" class="gift-card" elevation="10">

          <!-- IMAGEN -->
          <v-img :src="item.foto" height="220" contain class="gift-img"></v-img>


          <!-- CONTENIDO -->
          <v-card-text class="card-content">

            <h2 class="gift-title">{{ item.nombre }}</h2>

            <p class="gift-type">{{ item.tipo }}</p>

            <!-- Descripción con estilo igual al de tu vista bonita -->
            <div class="description-box">
              <div class="description-icon">🎁</div>
              <p class="description-text">
                {{ item.descripcion }}
              </p>
            </div>

            <div class="gift-info">
              <p><strong>Cantidad de regalo:</strong> {{ item.cantidad }}</p>
              <p><strong>Vigencia:</strong>
                {{ formatDate(item.fecha_inicio) }} —
                {{ formatDate(item.fecha_fin) }}
              </p>
            </div>
          </v-card-text>
          <!-- FOOTER -->
          <v-btn color="#1b4eae" class="btn-add" @click="addGiftToCart(item)">
            Agregar al carrito
          </v-btn>
        </v-card>
        
      </section>
      <CartDialog v-model="cartDialog" />
    </v-container>
  </v-app>
</template>


<style scoped>
/* Fondo */
.promo-bg {
  min-height: 50vh;
  padding-bottom: 20px;
}

/* Header elegante */
.header-box {
  text-align: center;
  padding: 32px 20px 16px;
}

.main-title {
  color: #222;
  font-size: 2rem;
  font-weight: 800;
}

.sub-title {
  color: #555;
  font-size: 1rem;
  margin-top: 6px;
}

/* GRID */
.cards-grid {

  display: grid;
  gap: 24px;
  padding: 0 14px;
  grid-template-columns: repeat(auto-fit, minmax(290px, 1fr));
  max-width: 1400px;
  margin: 0 auto;
}

/* Card */
.gift-card {
  border-radius: 16px;
  overflow: hidden;
  background: #fff;
  transition: 0.25s ease;
}

.gift-card:hover {
  transform: translateY(-8px);
  box-shadow: 0px 12px 28px rgba(0, 0, 0, 0.15);
}

/* Imagen */
.gift-img {
  position: relative;
}

/* Título */
.gift-title {
  font-size: 1.4rem;
  font-weight: 800;
  color: #1e1e1e;
  margin-bottom: 4px;
  text-align: center;
}

.gift-type {
  text-align: center;
  font-size: 0.9rem;
  font-weight: 600;
  color: #1b4eae;
  margin-bottom: 12px;
}

/* Caja de descripción igual estilo premium */
.description-box {
  display: flex;
  gap: 10px;
  background: #f7f7f7;
  border-left: 4px solid #c40000;
  padding: 12px 14px;
  border-radius: 10px;
  margin-bottom: 14px;
}

.description-icon {
  color: #c40000;
  font-size: 1.3rem;
}

.description-text {
  font-size: 0.95rem;
  color: #444;
  line-height: 1.4;
}

/* Información */
.gift-info p {
  margin: 4px 0;
  font-size: 0.85rem;
  color: #555;
}

/* Footer */
.card-actions {
  padding: 14px;
}

.btn-add {
  width: 100%;
  padding: 12px;
  font-weight: 700;
  color: white !important;
  border-radius: 10px !important;
}

.btn-add:hover {
  transform: translateY(-3px);
}
</style>



<script>
import axios from "axios";
import { inject, computed, ref } from "vue";
import CartDialog from "./Administrador/CarritoViewStore.vue"; // Asegúrate de que la ruta sea correcta
export default {
  name: "PromoView",
  components: { CartDialog },
  setup() {
    const cartStore = inject("cartStore");
    const totalCajas = computed(() => {
      return cartStore.state.cart.reduce((total, item) => total + item.quantity, 0);
    });

    const snackbar = ref(false);
    const snackbarText = ref("");

    const addGiftToCart = async (item) => {
      await cartStore.addGiftToCart(item);
    };

    const addToCart2 = async (item) => {
      if (!cartStore) {
        console.error("cartStore no está disponible");
        return;
      }
      await cartStore.addToCart2(item);
      snackbarText.value = "Promoción agregada al carrito";
      snackbar.value = true;
    };

    const searchQuery = ref("");
    const promotions = ref([]);
    const promoGifts = ref([]);
    const cartDialog = ref(false);
    const cart = ref(JSON.parse(localStorage.getItem("cart")) || []);

    return {
      addGiftToCart,
      totalCajas,
      addToCart2,
      snackbar,
      snackbarText,
      searchQuery,
      promotions,
      promoGifts,
      cartDialog,
      cart,
    };
  },

  computed: {
    filteredPromotions() {
      return this.searchQuery
        ? this.promotions.filter((promo) =>
          promo.nombre.toLowerCase().includes(this.searchQuery.toLowerCase())
        )
        : this.promotions;
    },
  },
  methods: {
    formatDate(dateStr) {
      const options = { year: "numeric", month: "short", day: "numeric" };
      return new Date(dateStr).toLocaleDateString("es-MX", options);
    },



    async fetchPromoGifts() {
      const cacheKey = "promoGiftsCache2";
      const cacheTimeKey = cacheKey + "_time";
      const cache = localStorage.getItem(cacheKey);
      const cacheTime = localStorage.getItem(cacheTimeKey);
      const now = Date.now();

      const oneMinute = 1 * 60 * 1000;

      if (cache && cacheTime && now - cacheTime < oneMinute) {
        this.promoGifts = JSON.parse(cache);
        return;
      }
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(
          "https://mvexpress.mx/api/promotions/promo-gift",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        this.promoGifts = response.data;

      } catch (err) {
        console.error("Error al cargar promociones de regalo:", err);
      }
    },

    openCart() {
      this.cartDialog = true;
    },



  },
  mounted() {
    this.fetchPromoGifts();
    const token = localStorage.getItem("token");
    if (!token) window.location.replace("/");
  },
};
</script>
